import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Switch } from "antd";
import { useSearchParams } from "react-router-dom";
import { svg } from "../../../../Assets/svg";
import { renderFormLabel } from "../../../../Components/Components";
import { useAppDispatch } from "../../../../store";
import { updateTeamMemberAPI } from "../../TeamMembers/teamMembersApis";

interface Props {
  open: boolean;
  onClose: () => void;
  refreshData?: () => void;
  clientId: string;
  preferencesData?: {
    color?: string | null;
    design_preview?: boolean;
  };
}

export const ModifyPreferencesModal: React.FC<Props> = ({
  open,
  onClose,
  refreshData,
  clientId,
  preferencesData,
}) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const quoteId = searchParams.get("quote_id");
  const orderId = searchParams.get("order_id");
  const contextualParams = quoteId
    ? { quote_id: quoteId }
    : orderId
    ? { order_id: orderId }
    : undefined;
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      if (preferencesData) {
        form.setFieldsValue({
          color: preferencesData.color || "", // Default to empty string for Input
          design_preview: preferencesData.design_preview || false,
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, preferencesData, form]);

  const onSave = async () => {
    try {
      const values = await form.validateFields();
      setSaving(true);

      const payload = {
        id: clientId,
        preferences: {
          color: values.color,
          design_preview: values.design_preview,
        },
      };

      dispatch(
        updateTeamMemberAPI({
          payload: payload,
          params: contextualParams,
          onSuccess: () => {
            setSaving(false);
            onClose();
            refreshData?.();
          },
          onError: () => {
            setSaving(false);
          },
        })
      );
    } catch (errorInfo) {
      console.log("Validation Failed:", errorInfo);
      setSaving(false);
    }
  };

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      closeIcon={svg?.closeIcon}
      width={"25rem"}
      className="commonModalClass"
      title={
        <div className="text-center fs-4 fw-bolder lh-m">
          Modify Preferences
        </div>
      }
    >
      <Form
        layout="vertical"
        form={form}
        className="page-form"
        onFinish={onSave}
        initialValues={{ design_preview: false }}
      >
        {/* Color Preference - Changed to Input */}
        <Form.Item
          label={renderFormLabel("Color Preference", false)}
          name="color"
          required={false}
        >
          <Input
            placeholder="Enter Color Preference"
            className="form-control form-control-lg"
          />
        </Form.Item>

        {/* Include Design Preview */}
        {/* <Form.Item
          label={renderFormLabel("Include Design Preview", false)}
          name="design_preview"
          valuePropName="checked"
          required={false}
        >
          <Switch checkedChildren="ON" unCheckedChildren="OFF" className="customSwitch" />
        </Form.Item> */}

        {/* Buttons */}
        <div className="d-flex justify-content-center gap-3 mt-4">
          <button
            onClick={onClose}
            className="btn btn-lg btn-outline-secondary h-auto px-4"
            type="button"
          >
            CLOSE
          </button>

          <Button
            htmlType="submit"
            loading={saving}
            className="btn btn-lg btn-dark h-auto px-4"
          >
            SAVE
          </Button>
        </div>
      </Form>
    </Modal>
  );
};
